import { isLocalStorageEnabled } from 'Lib/is-local-storage-enabled/is-local-storage-enabled';
import { speed } from 'Lib/speed/speed';

const $buyNow = $('.buy-now');
const $buyNowYouWatched = $('.buy-now_you-watched');
const $buyNowBasket = $('.buy-now_basket'); // Для страницы Корзины: там не нужно выводить книги, которые добавлены уже в корзину

if (isLocalStorageEnabled) {
    if (localStorage.getItem('booksViewed')) {
        const booksViewed = JSON.parse(localStorage.getItem('booksViewed'));

        if (booksViewed) {
            if ($buyNowBasket.length) {
                const timer = setInterval(() => {
                    if (JSON.parse(localStorage.getItem('booksViewedNoBasket'))?.length) {
                        const booksViewedNoBasket = JSON.parse(localStorage.getItem('booksViewedNoBasket'));

                        clearInterval(timer);
                        $buyNow.find('.books-slider').last().attr('data-post-load', booksViewedNoBasket.join());
                        localStorage.removeItem('booksViewedNoBasket');
                    }
                }, speed * 4);
            } else {
                $buyNowYouWatched.addClass('buy-now_you-watched-active');
                $('.buy-now__tabs-container-you-watched').find('.books-slider').attr('data-post-load', booksViewed.join());
            }
        }
    } else {
        $buyNowYouWatched.removeClass('buy-now_you-watched-active');
    }
}